<template lang="pug">

div
  app-modal-visualizar-completo(
        v-if="showModalVisualizarProcesso && idProcesso !== null",
        @closeModal="showModalVisualizarProcesso = false",
        :idProcesso="idProcesso",
        :protocolo="protocolo",
        :numeroProcesso="numeroProcesso",
        :tipo="tipoProcesso"
    )
  div(v-if="iframeSrc" class="iframe-wrapper")
    iframe(
        class="iframe-container"
        :src="iframeSrc",
        frameborder="0",
        allowfullscreen
      )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisarInformacoes",
      @limpar="clearInformacoes",
      :showFiltroSetor="true"
      :configuracaoFiltro="configuracaoFiltro",
      :configuracaoFiltroSituacao="configuracaoFiltroSituacao"
      :placeholder="'Informe o nome do responsável ou tipo de processo'"
      :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false",
    @exportarCsvFiltroAnalise="exportarCsvFiltroAnalise"

    )

</template>

<script>
import { mapActions } from 'vuex'
import Filtro from '@/screens/analise/listagem/Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppListagem from '@/components/AppListagem'

const { filtro, showFiltroTipoMultiplo } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('@/screens/analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    Filtro,
    AppListagem
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('CAIXA_RETIFICACAO'),
      showModalVisualizarProcesso: false,
      idProcesso: null,
      processo: {},
      protocolo: '',
      tipoProcesso: '',
      numeroProcesso: '',
      idUsuario: null,
      configuracaoFiltroSituacao: {},
      configuracaoFiltro: {
        filtroDataChegada: filtro?.filtroDataChegada?.CAIXA_RETIFICACAO || [],
        filtroCpf: filtro?.filtroCpf?.CAIXA_RETIFICACAO || [],
        filtroOrdemServico: filtro?.filtroOrdemServico?.CAIXA_RETIFICACAO || [],
        filtroFuncao: filtro?.filtroFuncao?.CAIXA_RETIFICACAO || []
      },
      items: [],
      showFiltroTipoMultiplo,
      totalElements: 0,
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Município', propriedade: 'municipio', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Data de atualização', propriedade: 'dataAlterado', ordem: 4, acoes: [] },
        { id: 5, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 4, acoes: [] },
        { id: 6, titulo: 'Responsável', propriedade: 'responsavel', ordem: 3, acoes: [] },
        {
              id: 7, titulo: 'Ações', propriedade: 'tipo', ordem: 7, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Retificar processo', icone: 'fa-check', codigo: 'RETIFICAR_PROCESSO', ordem: 2, show: this.showRetificarProcessso }
          ]
        }
      ],
      filtroRapido: null,
      iframeSrc: null
    }
  },
  async created () {
    const user = await this.getUsuario()
    this.idUsuario = user.id

    window.addEventListener('message', (event) => {
      if (event.data.tipo === 'ENCERRAR_SESSAO') {
        this.FECHAR_IFRAME()
        this.refresh()
      }
    })
  },
  methods: {
    ...mapActions({
      exportarCsvAnalise: 'processo/exportarCsvAnalise'
    }),
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.setDadosProcesso(item)
      this.showModalVisualizarProcesso = true
    },
    RETIFICAR_PROCESSO (_this, { item }) {
      this.iframeSrc = `${process.env.URL_REURB_WEB}/#/reurb/cadastros/cadastrar-reurb/geral?protocolo=${item.numeroProtocolo}&isRetificacaoGestao=${true}`
    },
    FECHAR_IFRAME () {
      this.iframeSrc = null
    },
    setDadosProcesso (item) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.processo = item
      this.protocolo = item.numeroProtocolo
      this.tipoProcesso = item.tipoCodigo
      this.processo = item
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    async exportarCsvFiltroAnalise () {
      await this.filtroComColunasExibidas()
      this.exportarCsvAnalise(this.filtro)
    }
  }
}
</script>

<style>
.iframe-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  flex-direction: column;
}

.iframe-container {
  width: 95vw;
  height: 90vh;
  border-radius: 10px;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaRetificacao.vue